import React from 'react';
import ContactEntryPointsContextPropTypes from './ContactEntryPointsContextPropTypes';
import entryPointsConfig from './ContactEntryPointsConfig';

export default React.createContext<ContactEntryPointsContextPropTypes>(
  entryPointsConfig,
);
